<div>
    <div *ngIf="defaultJSON != null && editabeJSON !=null ">

        <div class="c-title--subsection">Filter Label</div>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.filter_section.track}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.track" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontSize">{{defaultJSON.filter_section.sessionType}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.sessionType" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">{{defaultJSON.filter_section.sessionDate}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.sessionDate" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.sessionTime}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.sessionTime" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">{{defaultJSON.filter_section.location}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.location" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.sessionLevel}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.sessionLevel" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">{{defaultJSON.filter_section.tag}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.tag" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.industry}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.industry" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.jobFunction}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.jobFunction" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.clear_all}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.clear_all" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.my_session}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.my_session" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.show_my_sessions}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.show_my_sessions" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.show_my_fav}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.show_my_fav" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.unhide_session}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.unhide_session" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.time_zone}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.time_zone" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">{{defaultJSON.filter_section.hide_full_sessions}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.filter_section.hide_full_sessions" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

        </div>
        <div class="c-title--subsection">Cart Label</div>
        <div class="row">

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.cart_section.continue_with_registration}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.continue_with_registration" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerFontColor">{{defaultJSON.cart_section.selected}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.selected" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontStyle">{{defaultJSON.cart_section.favourites}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.favourites" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontSize">{{defaultJSON.cart_section.no_session_in_cart}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.no_session_in_cart" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.cart_section.no_fav_session}}</label>
                    </div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.no_fav_session" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerFontColor">{{defaultJSON.cart_section.add_to_schedule}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.add_to_schedule" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontStyle">{{defaultJSON.cart_section.remove_all}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.remove_all" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontSize">{{defaultJSON.cart_section.add_all_to_cart}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.cart_section.add_all_to_cart" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="c-title--subsection">My Schedule Label</div>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.my_schedule.my_schedule}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.my_schedule.my_schedule" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.my_schedule.done}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.my_schedule.done" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="c-title--subsection">Session Section Label</div>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.session_section.no_session}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.session_section.no_session" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.session_section.no_record_found}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.session_section.no_record_found" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.session_section.no_more_records_found}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.session_section.no_more_records_found" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="c-title--subsection">Catalog Section Label</div>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.catalog_section.login}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.catalog_section.login" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.catalog_section.logout}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.catalog_section.logout" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.catalog_section.clear_all}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.catalog_section.clear_all" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
        <div class="c-title--subsection">Tab Section Label</div>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">{{defaultJSON.tab_section.all_days}}</label></div>
                    <input class="c-form-group__input" [(ngModel)]="editabeJSON.tab_section.all_days" cclFormInput
                     />
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
    </div>
    </div>
    <div>
        <div class="c-title--subsection">Customized Error Message</div>
        <div class="row">
            <div class="col-sm-12">
                <div class="c-form-group">
                    <label class="label-lg text_size"> <strong> ** Please paste this ddf to show session details in error message - {{ddfText}} </strong></label>
                    <textarea id="cssStyle"
                        rows="10"
                        class="form-control"
                        [(ngModel)]="generalSessionConfig.catalogConfig.customizedError"
                    ></textarea>
                    <div class="clearfix"></div>
                </div>
                <div class="c-form-group__hint">&nbsp;</div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</div>